import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    // Snapshot before tom-select takes over the selects: it rewrites their option elements
    this.programOptions = this.snapshot(this.program(), 'accountId')
    this.surveyOptions = this.snapshot(this.survey(), 'programId')
  }

  filterPrograms() {
    this.repopulate(this.program(), this.programOptions, this.value(this.account()))
    this.filterSurveys()
  }

  filterSurveys() {
    this.repopulate(this.survey(), this.surveyOptions, this.value(this.program()))
    this.refreshParticipants()
  }

  refreshParticipants() {
    const sourceSurveyId = this.value(this.survey())
    const statuses = this.value(this.statuses())
    const participants = this.participants().tomselect
    document.getElementById('clone-submit').disabled = !sourceSurveyId || statuses.length === 0
    const params = new URLSearchParams({ source_survey_id: sourceSurveyId })
    statuses.forEach((status) => params.append('statuses[]', status))
    this.participants().dataset.loadUrl = sourceSurveyId ? `${this.element.dataset.respondentsUrl}?${params}` : ''

    participants.clear(true)
    participants.clearOptions(() => false)
    sourceSurveyId ? participants.enable() : participants.disable()
  }

  async selectAllMatching() {
    const participants = this.participants().tomselect
    const query = participants.lastQuery
    if (!this.participants().dataset.loadUrl || !query) return

    const url = new URL(this.participants().dataset.loadUrl, window.location.origin)
    url.searchParams.set('q', query)
    url.searchParams.set('all', '1')
    const respondents = await fetch(url, { headers: { Accept: 'application/json' } }).then((response) => response.json())
    participants.addOptions(respondents)
    participants.addItems(respondents.map((respondent) => respondent.value), true)
  }

  async submit() {
    const sourceSurveyId = this.value(this.survey())
    if (!sourceSurveyId) return

    const submitButton = document.getElementById('clone-submit')
    submitButton.disabled = true
    const response = await fetch(`${this.element.dataset.previewUrl}?source_survey_id=${sourceSurveyId}`, {
      headers: { "Accept": "application/json" }, credentials: "same-origin"
    })
    const data = await response.json()
    submitButton.disabled = false
    if (!response.ok) return

    if (data.mismatched.length === 0) {
      this.startClone()
    } else {
      document.getElementById('clone-preview-summary').textContent =
        `Will copy ${data.matched} of ${data.total} answers. These questions don't exist in this survey and will be skipped:`
      document.getElementById('clone-preview-list').innerHTML = data.mismatched.map((text) => `<li>${this.escape(text)}</li>`).join('')
      document.getElementById('clone-selection-step').classList.add('d-none')
      document.getElementById('clone-preview-step').classList.remove('d-none')
      submitButton.classList.add('d-none')
      document.getElementById('clone-confirm').classList.remove('d-none')
    }
  }

  proceed() {
    this.startClone()
  }

  startClone() {
    document.getElementById('clone-selection-step').classList.add('d-none')
    document.getElementById('clone-preview-step').classList.add('d-none')
    document.getElementById('clone-progress-step').classList.remove('d-none')
    document.getElementById('clone-submit').classList.add('d-none')
    document.getElementById('clone-confirm').classList.add('d-none')

    window.initiateCloneChannel(this.element.dataset.surveyId, this.element.dataset.enqueueUrl, this.value(this.survey()), this.completedAt().value,
                               this.value(this.statuses()), this.value(this.participants()))
  }

  snapshot(select, parentKey) {
    return Array.from(select.options).filter((option) => option.value)
      .map((option) => ({ value: option.value, text: option.text, parentId: option.dataset[parentKey] }))
  }

  repopulate(select, options, parentId) {
    const tomSelect = select.tomselect
    if (!tomSelect) return

    tomSelect.clear(true)
    tomSelect.clearOptions(() => false)
    if (parentId) {
      tomSelect.addOptions(options.filter((option) => option.parentId === parentId))
      tomSelect.enable()
    } else {
      tomSelect.disable()
    }
    tomSelect.refreshOptions(false)
  }

  value(select) {
    return select.tomselect ? select.tomselect.getValue() : select.value
  }

  escape(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }

  account() { return document.getElementById('clone-account') }
  program() { return document.getElementById('clone-program') }
  survey() { return document.getElementById('clone-source-survey') }
  completedAt() { return document.getElementById('clone-completed-at') }
  statuses() { return document.getElementById('clone-statuses') }
  participants() { return document.getElementById('clone-participants') }
}
